export function isUint8Array(data) {
    var _a, _b;
    return (data instanceof Uint8Array ||
        ((_a = data === null || data === void 0 ? void 0 : data.constructor) === null || _a === void 0 ? void 0 : _a.name) ===
            "Uint8Array" ||
        ((_b = data === null || data === void 0 ? void 0 : data.constructor) === null || _b === void 0 ? void 0 : _b.name) === "Buffer");
}
export function uint8ArrayToHexString(uint8Array) {
    var hexString = "0x";
    for (var _i = 0, _a = uint8Array; _i < _a.length; _i++) {
        var e = _a[_i];
        var hex = e.toString(16);
        hexString += hex.length === 1 ? "0".concat(hex) : hex;
    }
    return hexString;
}
//# sourceMappingURL=uint8array.js.map